import { create } from "zustand";


interface IPermitValidationDateModalStore {
    isModalOpen: boolean;
    permitValidationDate: string;
    openModal: (permitValidationDate: string) => void;
    closeModal: () => void;
}

export const usePermitValidationDateModalStore = create<IPermitValidationDateModalStore>()((set) => ({
    isModalOpen: false,
    permitValidationDate: '',
    openModal: (permitValidationDate: string) => set((state) => ({
        ...state,
        isModalOpen: true,
        permitValidationDate: permitValidationDate,
    })),
    closeModal: () => set((state) => ({
        ...state,
        isModalOpen: false,
        permitValidationDate: '',
    })),
}));


export const useIsOpenModalPVD = () => {
    return usePermitValidationDateModalStore((state) => state.isModalOpen);
}

export const useGetValidationDateModalPVD = () => {
    return usePermitValidationDateModalStore((state) => state.permitValidationDate);
}

export const useOpenPermitValidationDateModal = () => {
    return usePermitValidationDateModalStore((state) => state.openModal);
}

export const useClosePermitValidationDateModal = () => {
    return usePermitValidationDateModalStore((state) => state.closeModal);
}